import React from 'react';
import { Icon } from './icons.jsx';
// Drawer de detalhe de um evento de auditoria
const AuditDetailDrawer = ({ open, event, onClose }) => {
  if (!open || !event) return null;

  // Gera payload JSON "antes/depois" baseado no tipo de ação
  const getPayload = (ev) => {
    const a = ev.action || '';
    if (a.includes('Suspendeu')) return { status: { de: 'ativo', para: 'suspenso' } };
    if (a.includes('Ativou loja')) return { status: { de: 'suspenso', para: 'ativo' } };
    if (a.startsWith('Alterou plano')) {
      const match = a.match(/Alterou plano para (.+)/);
      return { plano: { de: '(plano anterior)', para: match ? match[1] : '—' } };
    }
    if (a.includes('Login como lojista')) return { tipo: 'impersonação', ator: ev.user, duracao: 'sessão ativa' };
    if (a.includes('Criou loja')) return { loja: ev.storeName, status_inicial: 'trial', plano: 'Basic' };
    if (a.includes('Reenviou fatura')) return { canal: 'e-mail', destinatario: 'proprietário da loja' };
    if (a.includes('Reenviou cobrança')) return { canal: 'e-mail', destinatario: 'proprietário da loja' };
    if (a.includes('Enviou notificação')) return { canal: a.split('via ')[1] || 'e-mail', mensagem: '(conteúdo omitido)' };
    if (a.includes('Criou usuário')) return { nome: ev.storeName !== '—' ? ev.storeName : '—', perfil: 'Suporte', status: 'ativo' };
    if (a.includes('Editou usuário')) return { campo_alterado: 'dados pessoais', status: 'ativo' };
    if (a.includes('Desativou usuário')) return { status: { de: 'ativo', para: 'inativo' } };
    if (a.includes('Reativou usuário')) return { status: { de: 'inativo', para: 'ativo' } };
    if (a.includes('configurações globais')) return { escopo: 'configurações SMTP e limites padrão' };
    return { acao: a };
  };

  const payload = getPayload(event);
  const payloadJson = JSON.stringify(payload, null, 2);

  // Formata timestamp para exibição completa
  const fullDate = event.timestamp instanceof Date
    ? event.timestamp.toLocaleString('pt-BR', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' })
    : event.when || '—';

  const initials = event.user.split(' ').map(n => n[0]).slice(0, 2).join('').toUpperCase();

  const Row = ({ label, value }) => (
    <div className="info-row">
      <span className="label">{label}</span>
      <span className="value">{value}</span>
    </div>
  );

  return (
    <>
      <div className="drawer-overlay" onClick={onClose} />
      <div className="drawer" style={{ width: 480 }}>
        <div className="drawer-head">
          <div style={{ width: 36, height: 36, borderRadius: 8, background: 'var(--bg-subtle)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--text-muted)', flexShrink: 0 }}>
            <Icon name="audit" size={18} />
          </div>
          <div style={{ flex: 1 }}>
            <h3>Detalhe do evento</h3>
            <div className="sub">{event.action}</div>
          </div>
          <button className="icon-action" onClick={onClose} style={{ width: 32, height: 32 }}>
            <Icon name="x" size={16} />
          </button>
        </div>

        <div className="drawer-body">
          {/* Ator */}
          <div className="drawer-section">
            <h4>Executado por</h4>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '10px 0' }}>
              <div className="store-avatar" style={{ background: 'var(--brand-navy)', width: 40, height: 40, borderRadius: 10, fontSize: 14 }}>
                {initials}
              </div>
              <div>
                <div style={{ fontWeight: 600, fontSize: 14 }}>{event.user}</div>
                <div style={{ fontSize: 12, color: 'var(--text-muted)' }}>Administrador interno</div>
              </div>
            </div>
          </div>

          {/* Informações do evento */}
          <div className="drawer-section">
            <h4>Informações</h4>
            <div className="info-list">
              <Row label="Ação" value={
                event.kind === 'danger'
                  ? <span className="badge danger"><span className="dot"></span>{event.action}</span>
                  : <span>{event.action}</span>
              } />
              <Row label="Loja relacionada" value={event.storeName || '—'} />
              <Row label="Data e hora" value={fullDate} />
              <Row label="Endereço IP" value={
                <span className="mono" style={{ fontSize: 12 }}>{event.ip || '—'}</span>
              } />
            </div>
          </div>

          {/* Payload */}
          <div className="drawer-section">
            <h4>Detalhes técnicos</h4>
            <div style={{
              background: 'var(--bg-subtle)', borderRadius: 'var(--radius)',
              border: '1px solid var(--border)',
              padding: '12px 14px', fontFamily: 'var(--font-mono, monospace)',
              fontSize: 12, color: 'var(--text-secondary)', lineHeight: 1.7,
              whiteSpace: 'pre',
            }}>
              {payloadJson}
            </div>
          </div>
        </div>

        <div className="drawer-foot">
          <span className="note">Registrado automaticamente pela plataforma.</span>
          <button className="btn ghost" onClick={onClose}>Fechar</button>
        </div>
      </div>
    </>
  );
};

export {
  AuditDetailDrawer,
};
